import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';
import { SubscriptionApi } from '../apis/subscription-api';
import CloseableErrorMessage from '../components/CloseableErrorMessage';

export const SubscriptionQueries = {
  useSubscription: (companyId: number | undefined, deleted: boolean = true) =>
    useQuery({
      queryKey: ['subscription', companyId],
      queryFn: async () => await SubscriptionApi.getSubscription(companyId!),
      enabled: !!companyId && !deleted,
      onError: () => CloseableErrorMessage('Error getting subscription.'),
      refetchOnWindowFocus: false,
    }),
    
  useUpdateProducts: (companyId: number) => {
    const queryClient = useQueryClient();
    return useMutation({
      mutationFn: async () => await SubscriptionApi.getUpdateProductsForCompany(companyId),
      onError: () => CloseableErrorMessage('Error syncing company products.'),
      onSuccess: () => {
        queryClient.invalidateQueries({queryKey: ['companyProducts', companyId]});
        message.success('Synced company products successfully.');
      }
    })
  }
};
